<template>
  <div>
    <h2
      class="m-0"
      v-text="'Bank Account'"
    />
    <p
      v-if="hasErrors"
      v-text="'Your bank account information could not be retrieved.'"
    />
    <BankAccountForm
      v-if="showForm"
      class="max-w-sm"
      @hideForm="showForm = false"
    />
    <BankAccountInfo
      v-else
      @showForm="showForm = true"
    />
  </div>
</template>

<script type="text/babel">
import { mapState } from 'vuex'
import BankAccountForm from './BankAccountForm'
import BankAccountInfo from './BankAccountInfo'

export default {
  name: 'BankAccountContainer',
  components: {
    BankAccountForm,
    BankAccountInfo,
  },
  data() {
    return {
      hasErrors: false,
      showForm: false,
      bankAccount: null,
    }
  },
  computed: {
    ...mapState({
      stripeAccount: state => state.payments.stripeAccount,
    }),
  },
  mounted() {
    this.showForm = this.stripeAccount.external_accounts.total_count === 0

    if (this.stripeAccount.external_accounts.total_count) {
      this.bankAccount = this.stripeAccount.external_accounts.data[0]
    }
  },
}
</script>